'use client';

import React, { useState } from 'react';
import ContactMethods from './ContactMethods';
import ConsultationForm from './ConsultationForm';
import ProjectInquiryForm from './ProjectInquiryForm';

interface ContactInteractiveProps {
  className?: string;
}

const ContactInteractive = ({ className = '' }: ContactInteractiveProps) => {
  const [activeForm, setActiveForm] = useState<string | null>(null);

  const handleMethodSelect = (methodId: string) => {
    if (methodId === 'consultation') {
      setActiveForm('consultation');
    } else if (methodId === 'inquiry') {
      setActiveForm('inquiry');
    } else if (methodId === 'phone') {
      window.location.href = 'tel:+15551234567';
    } else if (methodId === 'email') {
      window.location.href = 'mailto:hr.admin@sarviteq.com';
    }
  };

  const handleCloseForm = () => {
    setActiveForm(null);
  };

  return (
    <>
      <ContactMethods data-component-id="src/app/contact/components/ContactInteractive.tsx:33:6" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="33" data-component-end-line="33" data-component-file="ContactInteractive.tsx" data-component-name="ContactMethods" data-component-content="%7B%22elementName%22%3A%22ContactMethods%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" onMethodSelect={handleMethodSelect} className={className} />
      
      {activeForm === 'consultation' && (
        <ConsultationForm data-component-id="src/app/contact/components/ContactInteractive.tsx:36:8" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="36" data-component-end-line="36" data-component-file="ContactInteractive.tsx" data-component-name="ConsultationForm" data-component-content="%7B%22elementName%22%3A%22ConsultationForm%22%7D" onClose={handleCloseForm} />
      )}
      
      {activeForm === 'inquiry' && (
        <ProjectInquiryForm data-component-id="src/app/contact/components/ContactInteractive.tsx:40:8" data-component-path="src/app/contact/components/ContactInteractive.tsx" data-component-line="40" data-component-end-line="40" data-component-file="ContactInteractive.tsx" data-component-name="ProjectInquiryForm" data-component-content="%7B%22elementName%22%3A%22ProjectInquiryForm%22%7D" onClose={handleCloseForm} />
      )}
    </>
  );
};

export default ContactInteractive;